import React from "react";
import { object } from "prop-types";

import { EntityLanding } from "../../molecules/entity-landing";
import { STATIC_KEYWORDS } from "../../../constants";

export const PeopleLanding = ({ data, config }) => {
  return <EntityLanding config={config} data={data} page="people" headline={STATIC_KEYWORDS.PEOPLE} placeholder="Search People" />;
};

PeopleLanding.propTypes = {
  data: object,
};
